var map = {
	"./Games/knife_game.js": [
		670,
		0,
		9
	],
	"./quizBasic/quizBasic.js": [
		673,
		4,
		8
	],
	"./quizWithGame/quizWithGame.js": [
		674,
		0,
		6
	],
	"./stopwatch.js": [
		671,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 642;
module.exports = webpackAsyncContext;